import { axiosClient, axiosClientWithCustomUrl } from "../utils/axiosClient";
import {
  AUTH_ENDPOINT,
  PROPERTY_ENDPOINT,
  WEBHOOK_ENDPOINT,
} from "../utils/constant";

//Login and sinup with google
export const loginWithGoogle = (payload) => {
  return axiosClient(AUTH_ENDPOINT.GOOGLE_LOGIN, payload, "POST");
};

export const userlogin = (payload) => {
  return axiosClient(AUTH_ENDPOINT.LOGIN, payload, "POST");
};

export const userSignup = (payload) => {
  return axiosClient(AUTH_ENDPOINT.SINGUP, payload, "POST");
};

export const otpVerification = (payload) => {
  return axiosClient(AUTH_ENDPOINT.OTP_VERIFICATION, payload, "POST");
};

export const resendOtpAPI = (payload) => {
  return axiosClient(AUTH_ENDPOINT.RESEND_OTP, payload, "POST");
};

export const forgotPassword = (payload) => {
  return axiosClient(AUTH_ENDPOINT.FORGOT_PASSWORD, payload, "POST");
};
export const resetPassword = (payload) => {
  return axiosClient(AUTH_ENDPOINT.RESET_PASSWORD, payload, "POST");
};

export const changePassword = (payload) => {
  return axiosClient(AUTH_ENDPOINT.CHANGE_PASSWORD, payload, "POST");
};

export const accountDelete = (payload) => {
  return axiosClient(AUTH_ENDPOINT.ACCOUNT_DELETE, payload, "POST");
};

export const ToCheck = (payload) => {
  return axiosClient(AUTH_ENDPOINT.TEST, "", "GET");
};

export const ContactUsAPI = (payload) => {
  return axiosClient(AUTH_ENDPOINT.CONTACTUS, payload, "POST");
};

//property API's
export const filterPropertyAPI = (payload) => {
  return axiosClient(PROPERTY_ENDPOINT.FILTER_PROPERTY, payload, "POST");
};

//property API's to get the suggestions for budgety price
export const fetchBudgetPricing = (payload) => {
  return axiosClient(
    PROPERTY_ENDPOINT.BUDGET_PRICING_SUGGESTION,
    payload,
    "POST"
  );
};

//property API's to get the search results
export const filterPropertyList = (payload) => {
  return axiosClient(PROPERTY_ENDPOINT.FILTER_PROPERTY_LIST, payload, "POST");
};

//API to fetch chat history list with title
export const fetchChatHistoryListAPI = () => {
  return axiosClient(PROPERTY_ENDPOINT.CHAT_HISTORY_TITLE, {}, "POST");
};

//API to fetch chat deatls by id
export const fetchChatDetailsAPI = (payload) => {
  return axiosClient(PROPERTY_ENDPOINT.CHAT_HISTORY_DETAILs, payload, "POST");
};

//Calling wenhook
export const sendWebhookAPI = (payload) => {
  return axiosClient(PROPERTY_ENDPOINT.WEBHHOOK_REQUEST, payload, "POST");
};

export const sendWebhookAPI2 = (payload) => {
  return axiosClientWithCustomUrl(
    "https://www.birouinfo.ro/api/webhook-lfo",
    payload,
    "POST"
  );
};
